/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Risk_High_DetrainingInputs */

const en_coach_risk_high_detraining = /** @type {(inputs: Coach_Risk_High_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your fitness is declining and your recent load spike is in the high-risk zone. Back off immediately. Rebuild volume gradually over 2-3 weeks rather than trying to make up for lost time.`)
};

const de_coach_risk_high_detraining = /** @type {(inputs: Coach_Risk_High_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Fitness sinkt und der jüngste Belastungsanstieg liegt in der Hochrisikozone. Fahr sofort runter. Bau den Umfang über 2–3 Wochen langsam wieder auf — nicht alles auf einmal nachholen.`)
};

/**
* | output |
* | --- |
* | "Your fitness is declining and your recent load spike is in the high-risk zone. Back off immediately. Rebuild volume gradually over 2-3 weeks rather than tryi..." |
*
* @param {Coach_Risk_High_DetrainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_risk_high_detraining = /** @type {((inputs?: Coach_Risk_High_DetrainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Risk_High_DetrainingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_risk_high_detraining(inputs)
	return de_coach_risk_high_detraining(inputs)
});